const requestHandler = (request) => {
  return request;
};

export default requestHandler;
